import Api from "../../../Api";
import { modifyError } from "../../../Validation/ModifyErrros";

export const createNotifications = async (data) => {
  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let res = await Api.post("/notification", { ...data, userTimezone });

    return { data: res?.data?.data };
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getNotifications = async (query) => {
  try {
    const res = await Api.get("/notification", {
      params: {
        page: query.page,
        limit: query.limit,
        search: query.search,
      },
    });
    const data = res?.data?.data;
    return { data: data?.notifications, count: data?.count };
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getNotificationById = async (id) => {
  try {
    const res = await Api.get(`/notification/${id}`);
    const data = res?.data?.data;

    return { data };
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getSailingData = async () => {
  try {
    const res = await Api.get(`/notification/sailing/data`);
    const data = res?.data?.data;

    return { data };
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteNotification = async (id) => {
  try {
    let res = await Api.delete("/notification/" + id, {});

    return { data: res?.data?.notificationData, count: res?.data?.count };
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateNotification = async (id, data) => {
  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let res = await Api.put("/notification/" + id, { ...data, userTimezone });

    return { data: res?.data?.data };
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const handleStatus = async (id) => {
  try {
    let res = await Api.patch("/notification/change-status/" + id);

    return { data: res?.data?.notificationData, count: res?.data?.count };
  } catch (e) {
    return { error: "Failed to change status" };
  }
};

export const handleValidity = async (id, data) => {
  try {
    console.log({ id, data });
    let res = await Api.patch("/notification/handle-validity/" + id, data);

    return { data: res?.data?.notificationData, count: res?.data?.count };
  } catch (e) {
    return { error: "Failed to update validity" };
  }
};
